<template>
	<section class="studio">
		<div class="studio-scroller scroller" :data-dir="scroller">Studio</div>
		<div class="studio-container">
			<div class="studio-info">
                Triestink steht für fließende Linien und eine glasklare Vision von high-end Tattoos. Egal ob nach eigener Vorlage oder speziell für dich gestaltetem Motiv, hier wird jeder Wunsch restlos erfüllt - von Anime, Black &amp; Grey Realistic und Contemporary, über Fine Line, Horror und Ignorant bis hin zu Lettering, Neo Traditional und Mandala.
				<!-- In unserem Studio legen wir höchsten Wert auf Hygiene und professionelle Arbeit. Unsere erfahrenen Tätowierer und Piercer stehen dir mit Rat unt Tat zur Seite um deine Vision Realität werden zu lassen. Folge uns auf <a target="_blank" rel="noopener" href="https://www.instagram.com/jaks_tattoo/">Instagram</a> und <a target="_blank" rel="noopener" href="https://www.facebook.com/JAKSTattoo/">Facebook</a> für aktuelle Neuigkeiten und Infos zu regelmäßigen Aktionen. -->
			</div>
		</div>
	</section>
</template>

<script>
	export default {
		name: 'Studio',
		props: {
			scroller: String
		}
	}
</script>